'use client';

import { useEffect } from 'react';

import { useGlobalProps } from '@hen-site/component/GlobalContextProvider';

type PageIdRegistrarProps = {
  pageId?: number | string;
};

function normalizePageId(pageId: number | string | undefined): string {
  const value = String(pageId ?? '').trim();
  return /^\d+$/.test(value) && Number(value) > 0 ? value : '';
}

export function PageIdRegistrar({ pageId }: PageIdRegistrarProps) {
  const { updateGlobalProps } = useGlobalProps();
  const normalizedPageId = normalizePageId(pageId);

  useEffect(() => {
    updateGlobalProps({ id: normalizedPageId });

    return () => updateGlobalProps({ id: '' });
  }, [normalizedPageId, updateGlobalProps]);

  return null;
}
